export default __webpack_public_path__ + "sounds/gasp2.mp3";